import type React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, Card, Heading, Image, Paragraph } from '@zillow/constellation-10';

import LazyLoad from 'app/shared/components/LazyLoad';
import { emitExploreRentalsEvent } from 'app/shared/constants/MarketTrendsCSEvents';

import IllustrationTruckHome from 'images/zrmUpsell/illustration-truck-home.webp';

import type { State } from 'app/shared/types/State';

interface MarketUpsellProps {
  name: string;
  href: string;
}

const MarketUpsell: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<MarketUpsellProps>>> = (
  props,
) => {
  const { name, href } = props;
  const user = useSelector((state: State) => state.user);
  // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  const exploreRentals = useCallback(() => emitExploreRentalsEvent(user), []);
  return (
    <Card
      tone="neutral"
      css={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '400',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: '600',
        marginTop: '600',
      }}
    >
      <LazyLoad>
        <Image src={IllustrationTruckHome.src} alt="Moving truck in front of home" />
      </LazyLoad>
      {/* oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxWidth: 500px` is past the end of the numeric sizes scale, which stops at `5000` (200px); `flexBasis: 500px` is past the end of the numeric sizes scale, which stops at `5000` (200px) */}
      <Box css={{ maxWidth: '500px', flexBasis: '500px', textAlign: { _smallScreen: 'center' } }}>
        <Heading level={3} textStyle="heading-sm" fontFamily="heading-alt">
          Rent in {name}
        </Heading>
        <Paragraph>
          We created a seamless online experience for you - from shopping on the largest rental network, to applying, to
          paying rent.
        </Paragraph>
      </Box>
      <Button asChild tone="neutral" css={{ marginInline: '1200' }} onClick={exploreRentals}>
        <a href={href}>Explore Rentals</a>
      </Button>
    </Card>
  );
};

export default MarketUpsell;
